<style></style>
<template>
  <div class="">
    <div class="element-actions actions-only"></div>
    <h6 class="element-header" style="margin-bottom: 2px">Stock</h6>
    <div class="element-box-tp" style="padding: 0em !important">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>Tienda</th>
            <!--th class="text-center">Date</th-->
            <th class="text-center">V</th>
            <th class="text-right">Min</th>
            <th class="text-right">Max</th>
            <th class="text-right">Stock</th>
            <th class="text-right">En Reserva</th>
            <th class="text-right">Disponible</th>
            <!--th class="text-right"></th-->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="current_stock in tiendasfiltradas"
            v-bind:key="current_stock.id"
          >
            <td>
              <span>{{ current_stock.tienda }}</span>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_ventas == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_ventas == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-right text-bright">{{ current_stock.minimo }}</td>

            <td class="text-right text-bright">{{ current_stock.maximo }}</td>
            <td class="text-right">
              <span
                class="text-right text-success font-weight-bold"
                :class="{
                  'text-danger':
                    current_stock.existencia <= current_stock.minimo,
                  'text-warning':
                    current_stock.existencia > current_stock.maximo,
                }"
                >{{ current_stock.existencia }}</span
              >
            </td>
            <td class="text-right">
              <span class="text-right text-success"
                >{{ current_stock.existencia_en_reserva }}
              </span>
            </td>
            <td class="text-right">
              <span
                class="text-right text-success font-weight-bold"
                :class="{
                  'text-danger':
                    current_stock.existencia_disponible <= current_stock.minimo,
                  'text-warning':
                    current_stock.existencia_disponible > current_stock.maximo,
                }"
                >{{ current_stock.existencia_disponible }}</span
              >
            </td>
            <!--td>
                        <button class="btn btn-sm btn-warning">Editar</button>
            </td-->
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      datos: {
        tiendas: [],
      },
    };
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
    filtrartienda: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tiendasfiltradas() {
      let self = this;
      if (self.current.productotienda_set) {
        return self.current.productotienda_set.filter((t) => {
          return self.filtrartienda == null || t.tienda == self.filtrartienda;
        });
      }
      return [];
    },
  },
  mounted() {},
  methods: {
    
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
